import * as XLSX from "xlsx";

// Download client-side de uma lista de objetos (chave = cabeçalho da coluna).
// Mesmo mecanismo do studentsTable: o payload já está no navegador, não há
// motivo para uma ida ao backend só para gerar o arquivo.

const csvCell = (value) => {
  if (value == null) {
    return "";
  }
  if (typeof value === "number") {
    return String(value).replace(".", ",");
  }
  const text = String(value);
  if (/[;"\r\n]/.test(text)) {
    return `"${text.replace(/"/g, '""')}"`;
  }
  return text;
};

// CSV no dialeto pt-BR (";" separador, vírgula decimal): abre direto no Excel em
// português sem a etapa de "importar dados".
export const buildCsv = (rows) => {
  if (!rows.length) {
    return "";
  }
  const headers = Object.keys(rows[0]);
  const lines = [
    headers.map(csvCell).join(";"),
    ...rows.map((row) => headers.map((header) => csvCell(row[header])).join(";"))
  ];
  return lines.join("\r\n");
};

const triggerDownload = (blob, fileName) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

export const downloadAsCsv = (rows, fileName) => {
  // BOM: sem ele o Excel lê acentos como lixo.
  const blob = new Blob(["﻿", buildCsv(rows)], { type: "text/csv;charset=utf-8" });
  triggerDownload(blob, fileName);
};

export const downloadAsExcel = (rows, fileName, sheetName = "Dados") => {
  const book = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(book, XLSX.utils.json_to_sheet(rows), sheetName);
  XLSX.writeFile(book, fileName);
};
